export default {
  local: 'http://localhost:6003',
  development: 'https://betalogin.tron.com.br',
  production: 'http://login.tron.com.br',
};
